// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__mM2v7","inner":"styles_inner__ULwV8","new":"styles_new__70kNX","recommended":"styles_recommended__YEuPg"};